module.exports = __webpack_public_path__ + "media/images/personnel/Deborah_M-fc53d6f6f42423604eff6f6449a1eb51.png";